import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

// Define a version for translations - increment this when translations change
// This forces browsers to fetch new translations when this version changes
const TRANSLATIONS_VERSION = '1.20.0'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'el'],
    
    interpolation: {
      escapeValue: false,
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?v=' + TRANSLATIONS_VERSION,
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    defaultNS: 'common',
    ns: [
      'common', 
      'auth', 
      'home', 
      'profile', 
      'children', 
      'medicalHistory', 
      'bookings',
      'upcomingPeriods',
      'boxHelp'
    ],
  })

export default i18n 